/**
 * 全渠道门店设置 - 门店信息
 */

import { mapMutations } from 'vuex';

export default {
}
